var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "userControl" },
    [
      _c("div", { staticClass: "user-head" }, [
        _c("ul", [
          _c(
            "li",
            [
              _c("h5", [_vm._v("用户名")]),
              _vm._v(" "),
              _c("el-input", {
                model: {
                  value: _vm.form.userName,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "userName", $$v)
                  },
                  expression: "form.userName",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            [
              _c("h5", [_vm._v("手机号")]),
              _vm._v(" "),
              _c("el-input", {
                model: {
                  value: _vm.form.telephone,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "telephone", $$v)
                  },
                  expression: "form.telephone",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            [
              _c("h5", [_vm._v("邮箱")]),
              _vm._v(" "),
              _c("el-input", {
                model: {
                  value: _vm.form.email,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "email", $$v)
                  },
                  expression: "form.email",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            [
              _c("h5", [_vm._v("状态")]),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择" },
                  model: {
                    value: _vm.form.isNormal,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "isNormal", $$v)
                    },
                    expression: "form.isNormal",
                  },
                },
                _vm._l(_vm.options, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            [
              _c("h5", [_vm._v("云服务器")]),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择" },
                  model: {
                    value: _vm.form.fileServer,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "fileServer", $$v)
                    },
                    expression: "form.fileServer",
                  },
                },
                _vm._l(_vm.fileServers, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("li", [
            _c("h5", [_vm._v("注册开始时间")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "block" },
              [
                _c("el-date-picker", {
                  attrs: {
                    type: "date",
                    format: "yyyy/MM/dd",
                    "value-format": "yyyy-MM-dd",
                    placeholder: "选择日期",
                    editable: false,
                  },
                  model: {
                    value: _vm.form.createTimeStart,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "createTimeStart", $$v)
                    },
                    expression: "form.createTimeStart",
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("h5", [_vm._v("注册结束时间")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "block" },
              [
                _c("el-date-picker", {
                  attrs: {
                    type: "date",
                    format: "yyyy/MM/dd",
                    "value-format": "yyyy-MM-dd",
                    placeholder: "选择日期",
                    editable: false,
                  },
                  model: {
                    value: _vm.form.createTimeEnd,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "createTimeEnd", $$v)
                    },
                    expression: "form.createTimeEnd",
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "function" }, [
        _c("ol", [
          _c("li", { on: { click: _vm.search } }, [
            _c("img", {
              attrs: {
                src: require("../../assets/iconfont/find.png"),
                alt: "",
              },
            }),
            _vm._v(" "),
            _c("span", [_vm._v("查询")]),
          ]),
          _vm._v(" "),
          _c("li", { on: { click: _vm.empty } }, [
            _c("img", {
              attrs: {
                src: require("../../assets/iconfont/empty.png"),
                alt: "",
              },
            }),
            _vm._v(" "),
            _c("span", [_vm._v("清空")]),
          ]),
          _vm._v(" "),
          _c(
            "li",
            {
              directives: [
                {
                  name: "permit",
                  rawName: "v-permit",
                  value: "/snuser/update/telephone",
                  expression: "'/snuser/update/telephone'",
                },
              ],
              on: { click: _vm.changePhone },
            },
            [
              _c("img", {
                attrs: {
                  src: require("../../assets/iconfont/phone.png"),
                  alt: "",
                },
              }),
              _vm._v(" "),
              _c("span", { attrs: { id: "changePhone" } }, [
                _vm._v("修改手机号"),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              directives: [
                {
                  name: "permit",
                  rawName: "v-permit",
                  value: "/snuse/update/email",
                  expression: "'/snuse/update/email'",
                },
              ],
              on: { click: _vm.changeEmail },
            },
            [
              _c("img", {
                attrs: {
                  src: require("../../assets/iconfont/email.png"),
                  alt: "",
                },
              }),
              _vm._v(" "),
              _c("span", { attrs: { id: "changeEmail" } }, [
                _vm._v("修改邮箱"),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              directives: [
                {
                  name: "permit",
                  rawName: "v-permit",
                  value: "/snuser/Freeze",
                  expression: "'/snuser/Freeze'",
                },
              ],
              on: { click: _vm.freeze },
            },
            [
              _c("img", {
                attrs: {
                  src: require("../../assets/iconfont/frozen.png"),
                  alt: "",
                },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("冻结")]),
            ]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              directives: [
                {
                  name: "permit",
                  rawName: "v-permit",
                  value: "/snuser/Thaw",
                  expression: "'/snuser/Thaw'",
                },
              ],
              on: { click: _vm.unfreeze },
            },
            [
              _c("img", {
                attrs: {
                  src: require("../../assets/iconfont/thaw.png"),
                  alt: "",
                },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("解冻")]),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tab" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: { data: _vm.tableData, border: "" },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "index", index: _vm.indexMethod },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "userName", label: "昵称" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "countryCode", label: "国家码" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "telephone", label: "手机号" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "email", label: "电子邮箱" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "fileServer",
                  formatter: _vm.type,
                  label: "云服务器",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "createTime", label: "注册时间" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "isNormal", label: "状态" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "官方" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm.isOfficialUser(scope.row)
                          ? _c(
                              "el-tag",
                              { attrs: { type: "warning", size: "small" } },
                              [_vm._v("官方")]
                            )
                          : _c("span", [_vm._v("否")]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "管理员" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm.isAdminUser(scope.row)
                          ? _c(
                              "el-tag",
                              {
                                staticClass: "admin-tag",
                                attrs: { size: "small" },
                              },
                              [_vm._v("管理员")]
                            )
                          : _c("span", [_vm._v("否")]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", "min-width": _vm.opWidth },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "function-icon" },
                          [
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "permit",
                                    rawName: "v-permit",
                                    value: "/snuser/detail",
                                    expression: "'/snuser/detail'",
                                  },
                                ],
                                attrs: { size: "mini", plain: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.details(scope.row)
                                  },
                                },
                              },
                              [_vm._v("详情")]
                            ),
                            _vm._v(" "),
                            !_vm.isOfficialUser(scope.row)
                              ? _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "permit",
                                        rawName: "v-permit",
                                        value: "/snuser/official/add",
                                        expression: "'/snuser/official/add'",
                                      },
                                    ],
                                    staticClass: "official-btn",
                                    attrs: {
                                      size: "mini",
                                      type: "warning",
                                      plain: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.setOfficial(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("设为官方")]
                                )
                              : _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "permit",
                                        rawName: "v-permit",
                                        value: "/snuser/official/remove",
                                        expression: "'/snuser/official/remove'",
                                      },
                                    ],
                                    staticClass: "official-btn",
                                    attrs: {
                                      size: "mini",
                                      type: "danger",
                                      plain: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.cancelOfficial(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("取消官方")]
                                ),
                            _vm._v(" "),
                            !_vm.isAdminUser(scope.row)
                              ? _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "permit",
                                        rawName: "v-permit",
                                        value: "/snuser/admin/add",
                                        expression: "'/snuser/admin/add'",
                                      },
                                    ],
                                    staticClass: "official-btn",
                                    attrs: {
                                      size: "mini",
                                      type: "primary",
                                      plain: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.setAdmin(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("设置管理员")]
                                )
                              : _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "permit",
                                        rawName: "v-permit",
                                        value: "/snuser/admin/remove",
                                        expression: "'/snuser/admin/remove'",
                                      },
                                    ],
                                    staticClass: "official-btn",
                                    attrs: {
                                      size: "mini",
                                      type: "danger",
                                      plain: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.cancelAdmin(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("撤销管理员")]
                                ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "page" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: "total, prev, pager, next",
              "page-size": 10,
              total: _vm.total,
              "current-page": _vm.currentPage,
            },
            on: { "current-change": _vm.changepage },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "用户详情",
            visible: _vm.dialogVisibles,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisibles = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { staticClass: "form", attrs: { model: _vm.form } },
            [
              _c(
                "el-form-item",
                {
                  attrs: { label: "性别：", "label-width": _vm.formLabelWidth },
                },
                [
                  _c("el-input", {
                    attrs: { readonly: true },
                    model: {
                      value: _vm.sex,
                      callback: function ($$v) {
                        _vm.sex = $$v
                      },
                      expression: "sex",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: { label: "生日：", "label-width": _vm.formLabelWidth },
                },
                [
                  _c("el-input", {
                    attrs: { readonly: true },
                    model: {
                      value: _vm.birthday,
                      callback: function ($$v) {
                        _vm.birthday = $$v
                      },
                      expression: "birthday",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "个性签名：",
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("el-input", {
                    attrs: { readonly: true },
                    model: {
                      value: _vm.personalSign,
                      callback: function ($$v) {
                        _vm.personalSign = $$v
                      },
                      expression: "personalSign",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: { label: "喜好：", "label-width": _vm.formLabelWidth },
                },
                [
                  _c("el-input", {
                    attrs: { readonly: true },
                    model: {
                      value: _vm.hobby,
                      callback: function ($$v) {
                        _vm.hobby = $$v
                      },
                      expression: "hobby",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "教育程度：",
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("el-input", {
                    attrs: { readonly: true },
                    model: {
                      value: _vm.education,
                      callback: function ($$v) {
                        _vm.education = $$v
                      },
                      expression: "education",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: { label: "职业：", "label-width": _vm.formLabelWidth },
                },
                [
                  _c("el-input", {
                    attrs: { readonly: true },
                    model: {
                      value: _vm.job,
                      callback: function ($$v) {
                        _vm.job = $$v
                      },
                      expression: "job",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: { label: "地址：", "label-width": _vm.formLabelWidth },
                },
                [
                  _c("el-input", {
                    attrs: { readonly: true },
                    model: {
                      value: _vm.address,
                      callback: function ($$v) {
                        _vm.address = $$v
                      },
                      expression: "address",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisibles = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "修改手机号",
            visible: _vm.dialogFormVisible,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
            close: _vm.close,
          },
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.form } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "原手机号",
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c(
                    "el-input",
                    {
                      staticClass: "input-with-select",
                      attrs: { disabled: "" },
                      model: {
                        value: _vm.oldphone,
                        callback: function ($$v) {
                          _vm.oldphone = $$v
                        },
                        expression: "oldphone",
                      },
                    },
                    [
                      _c("el-select", {
                        staticStyle: { width: "120px" },
                        attrs: { slot: "prepend", disabled: "" },
                        slot: "prepend",
                        model: {
                          value: _vm.countryCode,
                          callback: function ($$v) {
                            _vm.countryCode = $$v
                          },
                          expression: "countryCode",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "新手机号",
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "list" },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { borderRight: "none", width: "150px" },
                          attrs: { filterable: "", placeholder: "请选择" },
                          model: {
                            value: _vm.newcountry,
                            callback: function ($$v) {
                              _vm.newcountry = $$v
                            },
                            expression: "newcountry",
                          },
                        },
                        _vm._l(_vm.cities, function (item) {
                          return _c(
                            "el-option",
                            {
                              key: item.value,
                              attrs: { label: item.code, value: item.code },
                            },
                            [
                              _c("span", { staticStyle: { float: "left" } }, [
                                _vm._v(_vm._s(item.code)),
                              ]),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    float: "right",
                                    color: "#8492a6",
                                    "font-size": "13px",
                                  },
                                },
                                [_vm._v(_vm._s(item.name))]
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _c("el-input", {
                        staticStyle: { paddingLeft: "0", borderLeft: "none" },
                        attrs: { maxlength: "15" },
                        model: {
                          value: _vm.newphone,
                          callback: function ($$v) {
                            _vm.newphone = $$v
                          },
                          expression: "newphone",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("取 消")]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: _vm.isDisable },
                  on: { click: _vm.save },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "修改邮箱",
            visible: _vm.dialogFormsVisible,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormsVisible = $event
            },
            close: _vm.close,
          },
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.form } },
            [
              _c(
                "el-form-item",
                {
                  attrs: { label: "原邮箱", "label-width": _vm.formLabelWidth },
                },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.oldemail,
                      callback: function ($$v) {
                        _vm.oldemail = $$v
                      },
                      expression: "oldemail",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: { label: "新邮箱", "label-width": _vm.formLabelWidth },
                },
                [
                  _c("el-input", {
                    attrs: { maxlength: "255", type: "text" },
                    model: {
                      value: _vm.newemail,
                      callback: function ($$v) {
                        _vm.newemail = $$v
                      },
                      expression: "newemail",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("取 消")]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: _vm.isDisable },
                  on: { click: _vm.keep },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }